import { ItemForExcel } from "../../../domain/Product";
import {
  ArticleEstimation,
  default as EstimationsModel,
  ItemEstimation,
  MonthEstimation,
} from "../../../domain/estimations/Estimations";
import { Month } from "../../admin/getEstimationMonths";
import { formatPrice } from "../../formatNumber";

interface Item {
  variantCode: string;
  sku: string;
  size: string;
  ean: string;
  eanPack?: string;
}

export interface Product {
  articleId: string;
  name: string;
  categories: string[];
  packageSize: number;
  items: Item[];
  discountedPrice: number;
  season?: string;
  isCollab?: string;
  collectionSegment?: string;
  assortmentSegment?: string;
}

export const createDataForExcel = (
  products: Product[],
  estimations: EstimationsModel,
  months: Month[]
): ItemForExcel[] => {
  return products
    .map((product: Product) => {
      const itemsEstimationForMonths: ItemEstimation[][] = [];
      months.forEach((month: Month) => {
        const itemEstimationForMonth = estimations
          .map((monthEstimation: MonthEstimation) => {
            return monthEstimation.articlesEstimations.find(
              (a: ArticleEstimation) =>
                a.articleId === product.articleId &&
                monthEstimation.month.month === month.month &&
                monthEstimation.month.year === month.year
            );
          })
          .filter((el) => el !== undefined);
        if (itemEstimationForMonth.length > 0) {
          itemsEstimationForMonths.push(
            itemEstimationForMonth[0]!.itemsEstimations
          );
        } else {
          itemsEstimationForMonths.push([]);
        }
      });
      return product.items.map(
        (item: Item): ItemForExcel => {
          return {
            articleName: product.name,
            categories: product.categories.join(";"),
            season: product.season,
            articleId: product.articleId,
            variantCode: item.variantCode,
            sku: item.sku,
            ean: item.ean,
            eanPack: item.eanPack,
            isCollab: product.isCollab,
            collectionSegment: product.collectionSegment,
            assortmentSegment: product.assortmentSegment,
            size: item.size,
            price: formatPrice(product.discountedPrice),
            packageSize: product.packageSize,
            estimationMonth1: getItemEstimationForMonth(
              itemsEstimationForMonths[0],
              item.sku
            ),
            estimationMonth2: getItemEstimationForMonth(
              itemsEstimationForMonths[1],
              item.sku
            ),
            estimationMonth3: getItemEstimationForMonth(
              itemsEstimationForMonths[2],
              item.sku
            ),
          };
        }
      );
    })
    .reduce((acc, product) => acc.concat(product), []);
};

const getItemEstimationForMonth = (
  itemsEstimationForMonth: ItemEstimation[],
  b: string
): number => {
  if (!itemsEstimationForMonth) {
    return 0;
  }
  const itemEstimationForMonth = itemsEstimationForMonth.find(
    (c: ItemEstimation) => c.sku === b
  );
  return itemEstimationForMonth ? itemEstimationForMonth.value : 0;
};



// WEBPACK FOOTER //
// ./src/view/estimations/export/createDataForExcel.ts